$ = jQuery.noConflict();

$(document).ready(function () {
  set_search_placeholder();
  $(window).resize(set_search_placeholder);

  const $search_input = $('.search-input');
  $('.search-btn-open').on('click', function () {
    toggle_search_box();
  });
  $('.search-btn-close').on('click', function () {
    toggle_search_box(0);

  });

  $search_input.on('keypress', function (e) {
    if (e.key === 'Enter') {
      const val = $(this).val().trim();
      window.location.replace('/blog?search=' + val);
    }
  });
});
function toggle_search_box(enabled = 1 ) {
  $('.search-btn-open').toggleClass('close', !!enabled);
  $('.tags-list').toggleClass('open', !!enabled);
  $('.search-input-wrapper').toggleClass('open', !!enabled);
  $('.search-input').toggleClass('rounded', !enabled);
}
function set_search_placeholder() {
  const placeholderValue = $(window).width() < 767 ? 'Search or select  a topic below' : 'Type and press enter to search or select  a topic below ';
  $('.search-input').attr('placeholder', placeholderValue);
}